import { render, staticRenderFns } from "./UpdateOrgBasic.vue?vue&type=template&id=5c6b23bc&"
import script from "./UpdateOrgBasic.vue?vue&type=script&lang=js&"
export * from "./UpdateOrgBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UpdateOrgBasic.vue"
export default component.exports